import { BaseFormType } from './types'

export const createDefaultValues: BaseFormType = {
  urlShortChannelUuid: null,
  urlShortAdvertiserUuid: null,
  urlShortTargetUrl: '',
  urlShortPageUrl: '',
  urlShortName: '',
}
